export default __webpack_public_path__ + "static/media/Common_Transition.e2109114.webm";